<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="aB" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18.8 21.9" style="enable-background:new 0 0 18.8 21.9;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#2684FF;}
	.st1{fill:url(#SVGID_1_BAMBOO);}
	.st2{fill:url(#SVGID_00000058548240908790937560000014399834403175337405_);}
</style>
<path class="st0" d="M16.4,12.2h-3.6c-0.2,0-0.4,0.2-0.4,0.4c-0.2,1.5-1.5,2.6-3,2.6l1,4.5c3.5-0.4,6.3-3.4,6.6-6.9
	C16.9,12.4,16.7,12.2,16.4,12.2z"/>
<path class="st0" d="M10.2,12l5.2-4.5c0.2-0.2,0.2-0.5,0-0.7l-5.2-4.5C9.9,2,9.4,2.3,9.4,2.7v9C9.4,12.1,9.9,12.3,10.2,12z"/>
<linearGradient id="SVGID_1_BAMBOO" gradientUnits="userSpaceOnUse" x1="5.6851" y1="-792.8485" x2="5.6851" y2="-803.1285" gradientTransform="matrix(1 0 0 -1 0 -788.1102)">
	<stop  offset="0" style="stop-color:#0052CC"/>
	<stop  offset="1" style="stop-color:#2684FF"/>
</linearGradient>
<path class="st1" d="M1.9,13.1c0.4,3.7,3.6,6.6,7.5,6.6v-4.5c-1.6,0-3-1.3-3-3L1.9,13.1z"/>
<linearGradient id="SVGID_00000075140605837118608660000007201214756016021145_" gradientUnits="userSpaceOnUse" x1="5.6291" y1="-792.8485" x2="5.6291" y2="-803.1285" gradientTransform="matrix(1 0 0 -1 0 -788.1102)">
	<stop  offset="0" style="stop-color:#0052CC"/>
	<stop  offset="1" style="stop-color:#2684FF"/>
</linearGradient>
<path style="fill:url(#SVGID_00000075140605837118608660000007201214756016021145_);" d="M1.9,12.1L1.9,12.1l4.5,0.1
	c0-1.6,1.3-3,3-3l-1-4.5C4.8,5.2,1.9,8.3,1.9,12.1z"/>
</svg>
